import React from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import QuanLyThuChiNgoaiLeApi from "../../../../../service/quanLyThuChiNgoaiLeApi";
import { pushNotification } from "utils/notifications";
import {
  getListQuanLyThuChiNgoaiLe,
  updateDataSearch,
} from "../../../../../actions/QuanLyThuChiNgoaiLe";
export const ModalXoa = (props) => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );
  const dispatch = useDispatch();
  const deleteThuChi = () => {
    // console.log(props);
    QuanLyThuChiNgoaiLeApi.xoaPhieuThuChi(props.thuChiId)
      .then((response) => {
        dispatch(getListQuanLyThuChiNgoaiLe(dataSearch));
      })
      .then(
        (response) => props.onHide(),
        pushNotification("Bạn đã xoá thành công", "success", "TOP_CENTER", 1000)
      );
  };

  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-delete"></i>
          </span>
          Xác nhận xoá
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group row">
                <label
                  className="col-md-12 label-control text-left"
                  for="projectinput2"
                >
                  Bạn có chắc chắn muốn xóa không?
                </label>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={deleteThuChi}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Xác nhận
        </button>

        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </button>
      </Modal.Footer>
    </Modal>
  );
};
